import { Badge, cn } from '@staff-app/ui';

/**
 * The User Type column's badge — same shape as `AuditActionBadge` so the two columns read alike.
 * Super User (staff acting through "Login as Customer") is the accent; Customer, which is most
 * rows, stays muted.
 */
export function UserTypeBadge({ isSuperUser }: { isSuperUser?: boolean | null }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'rounded-md border-0 whitespace-nowrap',
        isSuperUser ? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground',
      )}
    >
      {isSuperUser ? 'Super User' : 'Customer'}
    </Badge>
  );
}
